import { FC } from 'react';
import { Day, Locale } from 'date-fns';

import styles from './date-picker.less';

const DAYS: Day[] = [1, 2, 3, 4, 5, 6, 0];

export const Weekdays: FC<{ locale: Locale }> = ({ locale }) => {
    return (
        <div className={styles.weekdays} data-qa="date-picker-weekdays">
            {DAYS.map((eachWeekday) => (
                <div className={styles.weekday} key={`${eachWeekday}`}>
                    {locale.localize.day(eachWeekday, { width: 'short' })}
                </div>
            ))}
        </div>
    );
};
